/**
 * Helpers de data em ISO 8601. O backend e a API sempre falam ISO;
 * a formatacao pt-BR acontece somente na UI (ver `formatDateBR`).
 *
 * Datas de validade sao *dias* (YYYY-MM-DD), nao instantes: um item vence no
 * dia, nao as 14h32. Internamente representamos o dia como meia-noite UTC.
 */
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
export function isIsoDate(value) {
    const match = ISO_DATE.exec(value);
    if (!match)
        return false;
    const [, y, m, d] = match;
    const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)));
    return (date.getUTCFullYear() === Number(y) &&
        date.getUTCMonth() === Number(m) - 1 &&
        date.getUTCDate() === Number(d));
}
/** Converte uma data (ou ISO datetime) para o dia UTC em `YYYY-MM-DD`. */
export function toIsoDate(value) {
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime()))
        throw new Error(`Data invalida: ${String(value)}`);
    return date.toISOString().slice(0, 10);
}
/** Meia-noite UTC do dia informado, pronto para persistir como DateTime. */
export function isoDateToDate(value) {
    if (!isIsoDate(value))
        throw new Error(`Data invalida: ${value}`);
    return new Date(`${value}T00:00:00.000Z`);
}
export function addDays(value, days) {
    const date = isoDateToDate(value);
    date.setUTCDate(date.getUTCDate() + days);
    return toIsoDate(date);
}
/** Dias inteiros de `from` ate `to` (negativo quando `to` ja passou). */
export function daysBetween(from, to) {
    const ms = isoDateToDate(to).getTime() - isoDateToDate(from).getTime();
    return Math.round(ms / 86_400_000);
}
export function today(now = new Date()) {
    return toIsoDate(now);
}
/** Formatacao pt-BR (`dd/mm/aaaa`) — uso exclusivo de UI. */
export function formatDateBR(value) {
    const iso = typeof value === 'string' ? value : toIsoDate(value);
    const [y, m, d] = iso.slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
}
//# sourceMappingURL=dates.js.map